import Vue from 'vue';
import Card from './shared/Card';
import Cards from './shared/Cards';
import PageTitle from './shared/PageTitle';
import LanguageSwitch from './shared/LanguageSwitch';

Vue.component('card', Card);
Vue.component('cards', Cards);
Vue.component('page-title', PageTitle);
Vue.component('language-switch', LanguageSwitch);



// WEBPACK FOOTER //
// ./src/components/components.js